
import { FETCH_ALL, ADD_NEW, UPDATE, DELETE } from '../actions/constant'

const posts =(posts =[], action) => {
    switch (action.type) {
        case FETCH_ALL:
            return action.payload

        case ADD_NEW:
            return [...posts, action.payload]

        case UPDATE:
            return posts.map((post) => post._id === action.payload ? action.payload : post)
        
        case DELETE: 
        return posts.filter((post) => post._id !== action.payload)
        
        default:
            return posts;
    }
}

export default posts